import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  userInfo = JSON.parse(localStorage.getItem('userInfo')!);

  constructor() { }

  ngOnInit(): void { }

}
